<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card class="elevation-12">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>Giriş Yap</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form @submit.prevent="login">
              <v-text-field
                v-model="username"
                label="Kullanıcı Adı"
                prepend-icon="mdi-account"
                type="text"
                required
                :disabled="loading"
              ></v-text-field>

              <v-text-field
                v-model="password"
                label="Şifre"
                prepend-icon="mdi-lock"
                type="password"
                required
                :disabled="loading"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              @click="login"
              :loading="loading"
              :disabled="!username || !password"
            >
              Giriş Yap
            </v-btn>
          </v-card-actions>
          
          <v-alert
            v-if="error"
            type="error"
            class="ma-4"
          >
            {{ error }}
          </v-alert>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import apiClient, { setAuthCookie } from '@/plugins/axios'

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      loading: false,
      error: null
    }
  },
  methods: {
    async login() {
      this.loading = true
      this.error = null
      
      try {
        // Auth bilgilerini cookie'ye kaydet
        setAuthCookie(this.username, this.password)
        
        // Test isteği gönder
        await apiClient.get('/api/status')
        
        // Başarılı giriş, dashboard'a yönlendir
        this.$router.push('/')
      } catch (error) {
        this.error = 'Kullanıcı adı veya şifre hatalı'
        console.error('Login error:', error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>